import { styled } from '@mui/system';
import { Box, Link } from '@mui/material';
import React from 'react';

const SvgPlaceholderRoot = styled('div',{target: 'SvgPlaceholderRoot'})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  "& > div": {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  "& > svg": {
    filter: 'drop-shadow(2px 0px 1px #C2C3C6)'
  }
}));

const SvgPlaceholderSpan = styled('span')(({ theme }) => ({
  fontSize: '0.75rem',
  textAlign: 'center',
  whiteSpace: 'pre-wrap',
  color: theme.vars.palette.primary.textColor
}));

const SvgPlaceholderLink = styled(Link)(() => ({
  fontSize: '0.75rem',
  cursor: 'pointer'
}));

const SvgPlaceholder = React.forwardRef(({ icon: Icon, svg, msg, msgProps, link, onClickLink, innerStyle, isError },ref) => {

  const boldWordsInsideCurlyBrackets = (msg||'')
    .replace(/(?=[^{}]?)({(?!{)[^{}]+})/g, wordInsideCurlyBrackets =>
      `<strong>${wordInsideCurlyBrackets}</strong>`);

  return (
    <SvgPlaceholderRoot style={innerStyle}>
      {svg && <img src={svg} aria-hidden={true} alt=''/>}
      {Icon && <div style={{display: 'var(--mui-palette-show-creatures)'}}><Icon /></div>}
      <Box minHeight={24}>
        { msg &&
          <SvgPlaceholderSpan
            role='alert'
            ref={ref}
            style={{ color: isError ? 'var(--mui-palette-red-900)' : 'var(--mui-palette-secondary-textIconColor)'}}
            {...msgProps}
            dangerouslySetInnerHTML={{ __html: `<span>${boldWordsInsideCurlyBrackets}</span>` }} />}
          </Box>
      {link && onClickLink && <SvgPlaceholderLink onClick={onClickLink}>{link}</SvgPlaceholderLink>}
    </SvgPlaceholderRoot>
  )
})

export default SvgPlaceholder;
